import {observe} from 'selector-observer'
import {onInput} from '../onfocus'
import {remoteForm} from '@github/remote-form'
import {requestSubmit} from '../form'

function smsSending() {
  document.body.classList.add('is-sending')
  document.body.classList.remove('is-sent', 'is-not-sent')
}

function smsSuccess() {
  document.body.classList.add('is-sent')
  document.body.classList.remove('is-sending')
}

function smsError(message: string) {
  if (message) {
    document.querySelector<HTMLElement>('.js-sms-error')!.textContent = message
  }
  document.body.classList.add('is-not-sent')
  document.body.classList.remove('is-sending')
}

remoteForm('.js-send-auth-code', async (form, wants) => {
  smsSending()
  let response
  try {
    response = await wants.text()
  } catch (error) {
    smsError(error.response.text)
  }
  if (response) {
    smsSuccess()
  }
})

observe('.js-two-factor-sms-fallback-button', function (el) {
  // Reset fallback panes when dialog is toggled.
  el.addEventListener('toggle', function (event: Event) {
    const details = event.currentTarget as Element
    for (const flash of details.querySelectorAll('.flash')) {
      if (flash instanceof HTMLElement) {
        flash.hidden = true
      }
    }
    details.querySelector<HTMLElement>('.js-configure-sms-fallback')!.hidden = false
    details.querySelector<HTMLElement>('.js-verify-sms-fallback')!.hidden = true
  })
})

remoteForm('.js-two-factor-set-sms-fallback', async (form, wants) => {
  let response
  try {
    response = await wants.text()
  } catch (error) {
    const pane1 = form.querySelector<HTMLElement>('.js-configure-sms-fallback')!
    const pane2 = form.querySelector<HTMLElement>('.js-verify-sms-fallback')!
    const pane = pane1.hidden ? pane2 : pane1
    const flash = pane.querySelector<HTMLElement>('.flash')!
    switch (error.response.status) {
      case 422:
      case 429:
        flash.textContent = error.response.text
        flash.hidden = false
    }
  }
  if (response) {
    switch (response.status) {
      case 200:
      case 201:
        window.location.reload()
        break
      case 202:
        form.querySelector<HTMLElement>('.js-configure-sms-fallback')!.hidden = true
        form.querySelector<HTMLElement>('.js-verify-sms-fallback')!.hidden = false
        form.querySelector<HTMLElement>('.js-fallback-otp')!.focus()
        break
    }
  }
})

onInput('.js-verification-code-input-auto-submit', function (event: Event) {
  const target = event.currentTarget as HTMLInputElement
  const pattern = target.pattern || '[0-9]{6}'
  if (new RegExp(`^(${pattern})$`).test(target.value)) {
    requestSubmit(target.form!)
  }
})
